export type CalculatedPriceProductPromotion = {
	id: number;
	name: string;
	description: string;
	active: boolean;
	promotion_type: string;
	promotion_value: number;
	since: string;
	till: string;
	users_specification: string;
	products_specification: string;
	trigger: string;
	limit: any;
	code: any;
	system: string;
	is_packet: boolean;
	promo_days_period: number;
	grace_days_period: number;
	products: string[];
};

export type CalculatedPriceProduct = {
	uuid: string;
	current_price: number;
	next_price: number;
	standard_price: number;
	is_basic: boolean;
	promotion: CalculatedPriceProductPromotion | null;
};

export interface CalculatedPrice {
	current_price: number;
	next_price: number;
	standard_price: number;
	billing_period_start_on: string;
	billing_period_end_on: string;
	products: CalculatedPriceProduct[];
}

export enum CalculatePriceAction {
	New = 'new_subscription',
	Upgrade = 'upgrade_subscription',
	Downgrade = 'downgrade_subscription',
	AdditionalProducts = 'add_additional_products'
}

export type CalculatePricePayloadProduct = {
	uuid: string;
	price_id: number | null;
};
